webpackJsonp([136827681623915],{

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Hooks = __webpack_require__(102);
	
	var _Hooks2 = _interopRequireDefault(_Hooks);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Hooks2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Introduction'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Lore applications do a lot of things, including mounting the application, setting up routing, generating reducers and actions, and orchestrating data fetching for components. But at it\'s core, Lore doesn\'t have ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'any'
	      ),
	      ' of that functionality built into it.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Lore itself isn\'t a framework so much as a plugin engine, and it\'s all the plugins that combine to ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'make'
	      ),
	      ' it a framework for building React applications. At it\'s core, Lore only does two things:'
	    ),
	    _react2.default.createElement(
	      'ol',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Define the rules for how ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'config'
	        ),
	        ' files are loaded and combined'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Define the interface for what these plugins should look like, and how to specify dependencies between them, in order to determine the order they should be loaded'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'These plugins are referred to as ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'hooks'
	      ),
	      ', and new projects include a set of default hooks, which you can see if you open up the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'index.js'
	      ),
	      ' file at the root of your project:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // Hooks\n      import auth from \'lore-hook-auth\';\n      import actions from \'lore-hook-actions\';\n      import bindActions from \'lore-hook-bind-actions\';\n      import collections from \'lore-hook-collections\';\n      import connections from \'lore-hook-connections\';\n      import connect from \'lore-hook-connect\';\n      import models from \'lore-hook-models\';\n      import react from \'lore-hook-react\';\n      import reducers from \'lore-hook-reducers\';\n      import redux from \'lore-hook-redux\';\n      import router from \'lore-hook-router\';\n\n      // Summon the app!\n      lore.summon({\n        hooks: {\n          auth,\n          actions,\n          bindActions,\n          collections,\n          connections,\n          connect,\n          models,\n          react,\n          reducers,\n          redux: _.extend(redux, {\n            dependencies: [\'reducers\', \'auth\']\n          }),\n          router\n        }\n      });\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-index-js-cf19b69d6ea1f0640d44.js